import React, {useEffect, useRef, useState} from 'react';
import './EternalChestRewardModal.css';
import PageButton from "../../elements/PageButton/PageButton";
import {RUBY_COLOR} from "../../../styles/constants";
import {MENU_SOUND_MANAGER} from "../../../scenes/MenuSoundManager";

const PAGE_ID = 'EternalChestRewardModal';
const ETERNAL_CHEST_COLOR = RUBY_COLOR;

function EternalChestRewardModal({onClaim, onEntered}) {
  const [visible, setVisible] = useState(false);
  const enteredRef = useRef(false);

  useEffect(() => {
    MENU_SOUND_MANAGER.playChestEternal()
    const showTimer = setTimeout(() => setVisible(true), 50);
    return () => clearTimeout(showTimer);
  }, []);

  const handleClaim = () => {
    setVisible(false);
    setTimeout(() => {
      onClaim?.();
    }, 300);
  };

  const handleOverlayClick = (event) => {
    if (event.target === event.currentTarget) {
      handleClaim();
    }
  };

  const handleTransitionEnd = (event) => {
    if (event.target !== event.currentTarget) return;
    if (event.propertyName !== 'opacity') return;
    if (visible && !enteredRef.current) {
      enteredRef.current = true;
      onEntered?.();
    }
  };

  return (
    <div
      className={`eternal-chest-reward-overlay ${visible ? 'eternal-chest-reward-overlay_visible' : ''}`}
      onClick={handleOverlayClick}
      onTransitionEnd={handleTransitionEnd}
      role="dialog"
      aria-modal="true"
    >
      <div
        className={`eternal-chest-reward-modal ${visible ? 'eternal-chest-reward-modal_visible' : ''}`}
        style={{'--faction-color': ETERNAL_CHEST_COLOR}}
      >
        <div className="eternal-chest-reward-content">
          <div className="eternal-chest-reward-image-wrapper">
            <img
              className="eternal-chest-reward-image"
              src="/img/chests/chest_eternal.jpg"
              alt="Сундук Вечности"
            />
          </div>
          <div className="eternal-chest-reward-info">
            <h2 className="eternal-chest-reward-name">Сундук Вечности открыт!</h2>
            <span className="eternal-chest-reward-title">Поздравляем!</span>
            <p className="eternal-chest-reward-text">
              Отныне вам доступны абсолютно все фракции игры — не только уже
              существующие, но и все те, что будут добавлены в будущем.
            </p>
          </div>

          <div className="main-menu-buttons eternal-chest-reward-buttons">
            <PageButton onClick={handleClaim} pageId={PAGE_ID} buttonId="claim_reward">
              Отлично!
            </PageButton>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EternalChestRewardModal;
